import {Button, Container, Form, InputGroup, NavDropdown,} from "react-bootstrap";
import React, {Dispatch, Reducer, useCallback, useContext, useEffect, useReducer} from "react";
import UserAPIs from "../../apis/user.apis";
import {Link, useHistory, useLocation} from "react-router-dom";
import {
    failed_action_response,
    iResource,
    iResponseActions,
    iStoreAction,
    loading_action_response,
    responseReducer,
    success_action_response
} from "../../reducer";
import search_icon from "../../assets/images/serach.svg";
import useIsMounted from "ismounted";
import WindowSize from "@reach/window-size";
import {Formik} from "formik";
import {v4} from "uuid";
import {AppDispatchContext, AppStateContext} from "../../App";
import {IconButton} from "@material-ui/core";
import Highlighter from "react-highlight-words";
import "./style.scss"
import ProductApis, {iSearchResult} from "../../apis/product.apis";
import Axios, {CancelTokenSource} from "axios";

function SearchBox() {

    const {loggedInUser} = useContext(AppStateContext);
    const location = useLocation();
    const dispatch: Dispatch<iStoreAction> = useContext(AppDispatchContext);
    const isMounted = useIsMounted();
    const query = new URLSearchParams(location.search)
    const history = useHistory();


    return (<Container className="mt-2" key={location.key}>
            <Formik
                initialValues={{
                    keyword: (query.get("keyword") && query.get("keyword")) || "",
                }}
                onSubmit={(_values: any, helpers) => {
                    query.set("keyword", _values.keyword);
                    history.push({
                        pathname: "/books",
                        key: v4(),
                        search: "?" + query.toString()
                    })

                }}
            >
                {(
                    {
                        handleSubmit,
                        handleChange,
                        values,
                        setFieldValue,
                        submitForm
                    }: any) => {
                    return <form onSubmit={handleSubmit}>
                        <div className=" search-box">
                            <WindowSize>
                                {(size) => {
                                    if (size.width <= 500) {
                                        return <>
                                            {/* <div className="align-self-center login-create-button mb-1">
                                                {!loggedInUser &&
                                                <div
                                                    className={" d-flex align-items-center  login-create-button-child"}>
                                                    <Button
                                                        className="mx-2"
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={() => {
                                                            history.replace("/getting-started")
                                                        }}>
                                                        Create Account
                                                    </Button>
                                                    <Button className="login-button" variant="primary" size="sm"
                                                            onClick={() => {
                                                                history.replace("/login")
                                                            }}>
                                                        Login
                                                    </Button>
                                                </div>}
                                                {loggedInUser &&
                                                <div className="d-flex align-items-center login-create-button-child">


                                                    {(!location.pathname.includes("/dashboard") && !loggedInUser.admin) &&
                                                    <NavDropdown
                                                        className="search-box-drop-down"
                                                        title={<>Hello&nbsp;{loggedInUser && loggedInUser.first_name}</>}
                                                        id="basic-nav-dropdown">
                                                        <NavDropdown.Item as={Link} to="/dashboard/account">My
                                                            Account</NavDropdown.Item>
                                                        {
                                                            // loggedInUser.author && <NavDropdown.Item as={Link}
                                                            //                                          to="/dashboard/publish-new-book">Publish
                                                            //     New
                                                            //     Book</NavDropdown.Item>
                                                        }
                                                        {
                                                            loggedInUser.author &&
                                                            <NavDropdown.Item as={Link} to="/dashboard">My
                                                                Dashboard</NavDropdown.Item>
                                                        }
                                                        {
                                                            (loggedInUser.author && !loggedInUser.reviewer) &&
                                                            <NavDropdown.Item as={Link}
                                                                              to="/dashboard/account/become-reviewer">Become
                                                                a
                                                                Reviewer</NavDropdown.Item>
                                                        }
                                                        {
                                                            (!loggedInUser.author && loggedInUser.reviewer) &&
                                                            <NavDropdown.Item as={Link}
                                                                              to="/dashboard/account/become-author">Become
                                                                an
                                                                Author</NavDropdown.Item>
                                                        }
                                                    </NavDropdown>}
                                                    {(location.pathname.includes("/dashboard") || loggedInUser.admin) &&
                                                    <span className="mx-2"
                                                          style={{
                                                              cursor: "pointer",
                                                              maxLines: 1,
                                                          }} onClick={() => {
                                                        history.push("/dashboard");
                                                    }}>
                                                    Hello&nbsp;{loggedInUser && loggedInUser.first_name}
                                                    </span>}
                                                    <Button className="login-button" variant="outline-primary" size="sm"
                                                            onClick={() => {
                                                                new UserAPIs().logout().then((response) => {
                                                                    if (isMounted.current) {
                                                                        if (!UserAPIs.hasError(response)) {
                                                                            dispatch({
                                                                                type: "logout",
                                                                            })
                                                                            history.push("/login");
                                                                        }
                                                                    }
                                                                });
                                                            }}>
                                                        Logout
                                                    </Button>
                                                </div>}
                                            </div> */}
                                            <div className="align-self-center search-box-input">
                                                <SearchInput handleChange={handleChange} submitForm={submitForm}
                                                             values={values} setFieldValue={setFieldValue}/>
                                            </div>
                                        </>
                                    } else {
                                        return <>
                                            <div className="align-self-center search-box-input">
                                                <SearchInput handleChange={handleChange} submitForm={submitForm}
                                                             values={values} setFieldValue={setFieldValue}/>
                                            </div>
                                            {/* <div className="align-self-center login-create-button">
                                                {!loggedInUser &&
                                                <div
                                                    className={" d-flex align-items-center  login-create-button-child"}>
                                                    <Button
                                                        className="mx-2"
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={() => {
                                                            history.replace("/getting-started")
                                                        }}>
                                                        Create Account
                                                    </Button>
                                                    <Button className="login-button" variant="primary" size="sm"

                                                            onClick={() => {
                                                                history.replace("/login")
                                                            }}>
                                                        Login
                                                    </Button>
                                                </div>}
                                                {loggedInUser &&
                                                <div className="d-flex align-items-center login-create-button-child">


                                                    {(!location.pathname.includes("/dashboard") && !loggedInUser.admin) &&
                                                    <NavDropdown
                                                        className="search-box-drop-down"
                                                        title={<>Hello&nbsp;{loggedInUser && loggedInUser.first_name}</>}
                                                        id="basic-nav-dropdown">
                                                        <NavDropdown.Item as={Link} to="/dashboard/account">My
                                                            Account</NavDropdown.Item>

                                                        {
                                                            // loggedInUser.author && <NavDropdown.Item as={Link}
                                                            //                                          to="/dashboard/publish-new-book">Publish
                                                            //     New
                                                            //     Book</NavDropdown.Item>
                                                        }
                                                        {
                                                            loggedInUser.author &&
                                                            <NavDropdown.Item as={Link} to="/dashboard">My
                                                                Dashboard</NavDropdown.Item>
                                                        }
                                                        {
                                                            (loggedInUser.author && !loggedInUser.reviewer) &&
                                                            <NavDropdown.Item as={Link}
                                                                              to="/dashboard/account/become-reviewer">Become
                                                                a
                                                                Reviewer</NavDropdown.Item>
                                                        }
                                                        {
                                                            (!loggedInUser.author && loggedInUser.reviewer) &&
                                                            <NavDropdown.Item as={Link}
                                                                              to="/dashboard/account/become-author">Become
                                                                an
                                                                Author</NavDropdown.Item>
                                                        }

                                                    </NavDropdown>}
                                                    {(location.pathname.includes("/dashboard") || loggedInUser.admin) &&
                                                    <span className="mx-2"
                                                          style={{
                                                              cursor: "pointer",
                                                              maxLines: 1,
                                                          }} onClick={() => {
                                                        history.push("/dashboard");
                                                    }}>
                                                    Hello&nbsp;{loggedInUser && loggedInUser.first_name}
                                                </span>}
                                                    <Button className="login-button" variant="outline-primary" size="sm"
                                                            onClick={() => {
                                                                new UserAPIs().logout().then((response) => {
                                                                    if (isMounted.current) {
                                                                        if (!UserAPIs.hasError(response)) {
                                                                            dispatch({
                                                                                type: "logout",
                                                                            })
                                                                            history.push("/login");
                                                                        }
                                                                    }
                                                                });
                                                            }}>
                                                        Logout
                                                    </Button>
                                                </div>}
                                            </div> */}
                                        </>
                                    }
                                }}
                            </WindowSize>
                        </div>
                    </form>
                }}

            </Formik>
        </Container>
    );
}

export default SearchBox;

function SearchInput({
                         submitForm,
                         values,
                         handleChange,
                         setFieldValue
                     }: { submitForm: any, values: any, handleChange: any, setFieldValue: any }) {

    const [{
        loading,
        error_block,
        response,
        error
    }, dispatchResponse] = useReducer<Reducer<iResource<iSearchResult>, iResponseActions<iSearchResult>>>
    (responseReducer<iResource<iSearchResult>, any>({}), {loading: true});
    const isMounted = useIsMounted();
    const history=useHistory();

    const loadSuggestions = useCallback((source: CancelTokenSource) => {
        dispatchResponse(loading_action_response());
        new ProductApis().search_products(source, values.keyword).then((res) => {
            if (isMounted.current) {
                if (ProductApis.hasError(res)) {
                    dispatchResponse(failed_action_response(res.message))
                } else {
                    dispatchResponse(success_action_response(res))
                }
            }
        })
    }, [values]);

    useEffect(() => {
        let source = Axios.CancelToken.source();

        if(values.keyword && process.env.REACT_APP_SERIES=== "1"){
            loadSuggestions(source)
        }
        return () => {
            source.cancel()
        }
    }, [values.keyword])


    return <div>
        <InputGroup>
            <Form.Control
                onFocus={()=>{
                    setFieldValue("show_suggestion",true)
                }}
                className="search-text-input"
                type="text"
                maxLength={100}

                autoComplete="off"
                placeholder="Advance search"
                style={{
                    borderRight: "none",
                    borderBottomLeftRadius: "10px",
                    borderTopLeftRadius: "10px"
                }}
                name="keyword"
                value={values.keyword}
                onChange={(e)=>{
                    setFieldValue("show_suggestion",true)
                    handleChange(e)
                }}
            />


            <InputGroup.Prepend>
                <InputGroup.Text style={{
                    backgroundColor: "#fff",
                    borderLeft: "none",
                    borderBottomRightRadius: "10px",
                    borderTopRightRadius: "10px",
                    color: "#1EACAE",
                    padding: "0"
                }}>

                    <IconButton onClick={() => {
                        submitForm().then()
                    }} style={{padding: "8px"}}>
                        <img src={search_icon} style={{
                            height: "16px",
                            cursor: "pointer"
                        }}
                             alt={"search icon"}
                        />
                    </IconButton>


                </InputGroup.Text>
            </InputGroup.Prepend>

        </InputGroup>

        {
            process.env.REACT_APP_SERIES=== "1" && <div className={`search-overlay-wrapper ${values.keyword && values.show_suggestion ? "show" : ""}`}>

                <div className={"search-overlay"}>
                    <div className="search-suggestion-list">
                        <ul>
                            {
                                [
                                    {
                                        type: "all",
                                        name: values.keyword,
                                        value: values.keyword
                                    },
                                    ...(response && response.products && response.products.map((v, i) => {
                                        return {
                                            type: "product",
                                            name: v.title,
                                            value: v
                                        }
                                    })) || [],
                                    ...(response && response.series && response.series.map((v, i) => {
                                        return {
                                            type: "series",
                                            name: v.name,
                                            value: v
                                        }
                                    })) || [],

                                ].map(((value, index) => {

                                    if (value.type === "product") {
                                        return <li key={index} className="search-suggestion-list-item list-item-series"
                                                   onClick={() => {
                                                       setFieldValue("show_suggestion",false)
                                                       history.push(`/book/${value.value.seo_text}/${value.value.id}`)
                                                   }}>
                                            <div className="search-suggestion-list-item-wrapper">
                                                <div>
                                                    <SearchResultText value={value.name} keyword_searched={values.keyword}/>
                                                    <span className="search-suggestion-list-item-cat"> in Books</span>
                                                </div>

                                            </div>
                                        </li>
                                    }
                                    if (value.type === "series") {
                                        return <li key={index} className="search-suggestion-list-item list-item-series"
                                                   onClick={() => {

                                                       setFieldValue("show_suggestion",false)
                                                       history.push(`/series/${value.value.acronym}`)
                                                   }}>
                                            <div className="search-suggestion-list-item-wrapper">
                                                <div>
                                                    <SearchResultText value={value.name} keyword_searched={values.keyword}/>
                                                    <span className="search-suggestion-list-item-cat"> in Series</span>
                                                </div>

                                            </div>
                                        </li>
                                    }
                                    return <li key={index} className="search-suggestion-list-item" onClick={() => {

                                        setFieldValue("show_suggestion",false)
                                        submitForm().then()
                                    }}>
                                        <div className="d-flex justify-content-between">
                                            <div className="search-suggestion-list-item-wrapper">
                                                <SearchResultText value={value.name} keyword_searched={values.keyword}/>
                                            </div>
                                            <div className="search-suggestion-list-item-help">
                                            <span>
                                            Search in all books
                                            </span>
                                            </div>
                                        </div>
                                    </li>

                                }))
                            }

                        </ul>
                    </div>
                </div>
            </div>
        }

    </div>
}

function SearchResultText({value, keyword_searched}: { value: string, keyword_searched: string }) {
    return <Highlighter
        highlightClassName="search-suggestion-list-item-highlight"
        searchWords={keyword_searched.split(' ')}
        autoEscape={true}
        textToHighlight={value}
    />
}
